import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'product_page-information_section_toggle-click';
/**
 * Click on the information section on the product page
 */
export function trackProductPageInformationSectionToggleClick(actionType_string, productToken) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: { actionType_string, productToken },
    });
}
